function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_38_2",
  "data-name": "Component 38 \\u2013 2",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "FontAwsome_file_",
  "data-name": "FontAwsome (file)",
  d: "M52.244,13.741,40.394,1.891A6.78,6.78,0,0,0,35.606-.1H6.779A6.8,6.8,0,0,0,0,6.694V65.449a6.781,6.781,0,0,0,6.779,6.779H47.456a6.781,6.781,0,0,0,6.779-6.779V18.543a6.812,6.812,0,0,0-1.991-4.8Zm-5.339,4.251H36.157V7.244ZM6.779,65.449V6.694h22.6V21.382a3.382,3.382,0,0,0,3.39,3.39H47.456V65.449Z",
  transform: "translate(0 0.1)",
  fill: "#ac1ede",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "FontAwsome_map-marker-alt_",
  "data-name": "FontAwsome (map-marker-alt)",
  d: "M8.075,23.516C1.264,13.642,0,12.629,0,9A9,9,0,1,1,18,9c0,3.629-1.264,4.642-8.075,14.516a1.125,1.125,0,0,1-1.85,0ZM9,12.75A3.75,3.75,0,1,0,5.25,9,3.75,3.75,0,0,0,9,12.75Z",
  transform: "translate(17.66 30.182)",
  fill: "#ac1ede",
  stroke: "#fff",
  strokeWidth: 1
}));

var SvgMapfile = function SvgMapfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.235,
    height: 74.328,
    viewBox: "0 0 56.235 74.328",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mapfile.e65355ac.svg";
export { ForwardRef as ReactComponent };